import { render, staticRenderFns } from "./LocalPostStats.vue?vue&type=template&id=2550d628&scoped=true&"
import script from "./LocalPostStats.vue?vue&type=script&lang=js&"
export * from "./LocalPostStats.vue?vue&type=script&lang=js&"
import style0 from "./LocalPostStats.vue?vue&type=style&index=0&id=2550d628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2550d628",
  null
  
)

export default component.exports